import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import StyledDialog from './styledDialog';
import { MauContainedBtn } from './MauButtonSet';
import "../css/aggrementStyle.css";
const UserAgreementDialog = ({
  open, action, agreement, close
}) => {
  const { push } = useHistory();
  const [red, setRed] = useState(false);
  return (
    <StyledDialog
      open={open}
    >
      <DialogTitle id="alert-dialog-title">
        Agreement
      </DialogTitle>
      <DialogContent className='aggrement'>
        <span dangerouslySetInnerHTML={{ __html: agreement }} />
      </DialogContent>
      <DialogActions className="actnbtnSWrap user-agreement-con">
        <div>
          <h5>Acknowledgment and Acceptance</h5>
          <FormControlLabel
            control={(
              <Checkbox
                checked={red}
                style={{
                  color: '#1367B2',
                }}
                onChange={() => setRed((prev) => !prev)}
              />
            )}
            label="I have read, understood, and agree to the terms outlined above. I consent to the recording and use of my appointment content for the stated purposes."
          />
        </div>
        <div className="agreement-action-btn">
          <MauContainedBtn
            variant="contained"
            className="iunderstand"
            onClick={close}
          >
            Return to Home
          </MauContainedBtn>
          <MauContainedBtn
            variant="contained"
            className="iunderstand"
            disabled={!red}
            onClick={action}
          >
            I Agree
          </MauContainedBtn>
        </div>
      </DialogActions>
    </StyledDialog>
  );
};

export default UserAgreementDialog;
